import { render } from "./UserProfileContents.vue?vue&type=template&id=b0c65e92&scoped=true"
import script from "./UserProfileContents.vue?vue&type=script&lang=js"
export * from "./UserProfileContents.vue?vue&type=script&lang=js"

import "./UserProfileContents.vue?vue&type=style&index=0&id=b0c65e92&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-b0c65e92"

export default script